var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"u-container"},[(_vm.page === 1)?_c('FindIdForm',{on:{"nextPage":_vm.nextPage}}):_vm._e(),(_vm.page === 2)?_c('FindIdResult'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }